// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.entity-form-view[data-v-131570cd] {
	background-color: #f8f9fa;
}
fieldset[data-v-131570cd] {
		border: 1px solid #ced4da;
		padding: 1rem;
		border-radius: .25rem;
}
legend[data-v-131570cd] {
		width: auto;
		font-size: 1.2rem;
		padding: 0 0.5rem;
		width: 100%;
}
.property .value[data-v-131570cd] {
	line-height: 2.5rem;
}
[data-v-131570cd] .vue-codemirror .CodeMirror{
	border: var(--bs-border-width) solid var(--bs-border-color);
	border-radius: .375rem;
	min-height: 38px;
}
[data-v-131570cd] .vue-codemirror:focus-within .CodeMirror{
	border-color: #86b7fe;
	box-shadow: none !important;
}
.key-input[data-v-131570cd]::placeholder {
	color: #adb5bd;
	opacity: 1;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
